import { render, staticRenderFns } from "./chatLevel.vue?vue&type=template&id=187764cb"
import script from "./chatLevel.vue?vue&type=script&lang=js"
export * from "./chatLevel.vue?vue&type=script&lang=js"
import style0 from "./chatLevel.vue?vue&type=style&index=0&id=187764cb&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports